<template>
    <v-container>
        <h3 class="display-1 font-weight-bold">Manage Instaplays</h3>
        <v-expansion-panel class="py-4 elevation-0" v-model="panels" expand>
            <v-expansion-panel-content
                    v-for="(mode, i) in modes"
                    :key="i"
            >
                <template v-slot:header>
                    <div class="text-capitalize">{{count(mode)}} {{modeTitles[mode]}}</div>
                </template>
                <v-layout column>
                    <instaplay-card
                            v-for="(game, i) in sortedInstaplays(mode)"
                            :key="game.timeStamp"
                            :instaplay="game"
                            :mode="mode"
                            @wsdeclare="(alert) => openAlertDialog(mode, 'declareWinner', i, alert)"
                            @showWinner="showWinner(mode, i)"
                            @delete="openAlertDialog(mode, 'delete', i, true)"
                            @edit="openEditDialog(mode, i)"
                            :manage="true"
                            class="my-2"
                    />
                </v-layout>
                <v-card-actions v-if="isThereMore(mode) || isLoading(mode)">
                    <v-spacer/>
                    <v-btn @click="loadMoreInstaplays({mode})" :loading="isLoading(mode)" flat>load more</v-btn>
                    <v-spacer/>
                </v-card-actions>
            </v-expansion-panel-content>
        </v-expansion-panel>


        <declare-winner
                :instaplay="WSDialog.instaplay"
                ref="declareWinner"
                :mode="dialogMode"
                @declared="fetchIds"
        />

        <v-dialog v-model="alertDialog.dialog" max-width="320">
            <v-card>
                <v-card-title class="headline">{{alertDialog.message}}</v-card-title>

                <v-card-actions>
                    <v-spacer/>

                    <v-btn
                            color="warning"
                            flat="flat"
                            round
                            @click="alertDialog.dialog = false"
                    >
                        {{alertDialog.secondary}}
                    </v-btn>

                    <v-btn
                            color="warning"
                            depressed
                            round
                            @click="alertDialogAction"
                            :loading="alertDialogLoading"
                    >
                        {{alertDialog.primary}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="editDialog.dialog" fullscreen transition="dialog-bottom-transition">
            <v-card>
                <v-card-title class="headline justify-space-between" primary-title>
                    Edit Instaplay
                    <v-btn icon @click="closeEditDialog">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-container>
                    <instaplay-form ref="instaplayForm" edit/>
                </v-container>

                <v-divider/>

                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                            round color="warning"
                            flat
                            @click="closeEditDialog"
                    >
                        discard
                    </v-btn>
                    <v-btn
                            round color="warning"
                            depressed
                    >
                        save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
    import InstaplayCard from "@/components/InstaplayCard";
    import InstaplayForm from "@/components/InstaplayForm";
    import {mapActions, mapGetters} from "vuex";
    import DeclareWinner from "@/components/DeclareWinner";
    import {isPassed} from "@/services/time";

    export default {
        name: "Manage",
        components: {DeclareWinner, InstaplayForm, InstaplayCard},
        data() {
            return {
                modes: ['manageActive', 'manageWaiting', 'manageDeclared'],
                dialogMode: 'manageActive',
                panels: [true, false, false],
                modeTitles: {
                    manageActive: "active",
                    manageWaiting: "waiting",
                    manageDeclared: "declared",
                },
                status: {
                    delete: '',
                },
                WSDialog: {
                    instaplay: {},
                    i: ''
                },
                alertDialog: {
                    dialog: false,
                    message: '',
                    action: '',
                    primary: 'yes',
                    secondary: 'no',
                    i: '',
                    id: ''
                },
                editDialog: {
                    dialog: false,
                    instaplay: {},
                    privacyItems: [
                        {name: 'Me Only', avatar: require('../assets/user.svg')},
                        {name: 'By Invitation', avatar: require('../assets/email.svg')},
                        {name: 'Public', avatar: require('../assets/group.svg')}
                    ]
                },
            }
        },
        computed: {
            ...mapGetters('instaplays', ['instaplays', 'isLoading', 'isThereMore', 'isSuccess', 'count']),

            alertDialogLoading() {
                return this.alertDialog.action === 'delete' ? this.status.delete === 'loading' : false
            }
        },
        methods: {
            ...mapActions('instaplays', ['fetchUserIDs', 'loadMoreInstaplays', 'deleteInstaplay']),
            fetchIds() {
                this.fetchUserIDs('manageActive')
                this.fetchUserIDs('manageWaiting')
                this.fetchUserIDs('manageDeclared')
            },
            sortedInstaplays(mode) {
                return this.instaplays[mode].slice()
                    .sort(
                    (a, b) => {
                        if (a.declareYear && !b.declareYear)
                            return 1
                        else if (!a.declareYear && b.declareYear)
                            return -1
                        else if (a.declareYear && b.declareYear)
                        {
                            if (new Date(a.declareYear, a.declareMonth - 1, a.declareDay, a.declareHour, a.declareMinute)
                                < new Date(b.declareYear, b.declareMonth - 1, b.declareDay, b.declareHour, b.declareMinute)) {
                                return 1
                            } else {
                                return -1
                            }
                        }

                        if (isPassed(a.winnerYear, a.winnerMonth, a.winnerDay, a.winnerHour, a.winnerMinute)
                            && !isPassed(b.winnerYear, b.winnerMonth, b.winnerDay, b.winnerHour, b.winnerMinute)) {
                            return -1
                        } else if (!isPassed(a.winnerYear, a.winnerMonth, a.winnerDay, a.winnerHour, a.winnerMinute)
                            && isPassed(b.winnerYear, b.winnerMonth, b.winnerDay, b.winnerHour, b.winnerMinute)) {
                            return 1
                        } else if (isPassed(a.winnerYear, a.winnerMonth, a.winnerDay, a.winnerHour, a.winnerMinute)
                            && isPassed(b.winnerYear, b.winnerMonth, b.winnerDay, b.winnerHour, b.winnerMinute)) {
                            return 0
                        } else {
                            if (isPassed(a.startYear, a.startMonth, a.startDay, a.startHour, a.startMinute)
                                && !isPassed(b.startYear, b.startMonth, b.startDay, b.startHour, b.startMinute)) {
                                return -1
                            } else if (!isPassed(a.startYear, a.startMonth, a.startDay, a.startHour, a.startMinute)
                                && isPassed(b.startYear, b.startMonth, b.startDay, b.startHour, b.startMinute)) {
                                return 1
                            } else if (isPassed(a.startYear, a.startMonth, a.startDay, a.startHour, a.startMinute)
                                && isPassed(b.startYear, b.startMonth, b.startDay, b.startHour, b.startMinute)) {
                                if (new Date(a.winnerYear, a.winnerMonth - 1, a.winnerDay, a.winnerHour, a.winnerMinute)
                                    < new Date(b.winnerYear, b.winnerMonth - 1, b.winnerDay, b.winnerHour, b.winnerMinute)) {
                                    return -1
                                } else {
                                    return 1
                                }
                            } else {
                                if (new Date(a.startYear, a.startMonth - 1, a.startDay, a.startHour, a.startMinute)
                                    < new Date(b.startYear, b.startMonth - 1, b.startDay, b.startHour, b.startMinute)) {
                                    return -1
                                } else {
                                    return 1
                                }
                            }
                        }
                    }
                )
            },
            alertDialogAction() {
                this.alertDialog.dialog = false
                switch (this.alertDialog.action) {
                    case 'declareWinner':
                        this.openWSDialog(this.dialogMode, this.alertDialog.i)
                        break
                    case 'delete':
                        this.removeInstaplay(this.dialogMode, this.alertDialog.id)
                }
            },
            openAlertDialog(mode, action, i, alert) {
                this.dialogMode = mode
                switch (action) {
                    case 'declareWinner':
                        this.alertDialog.message = 'There is time remaining for this Instaplay. Are you sure you want to close and declare its winner?'
                        break
                    case 'delete':
                        this.alertDialog.message = 'Are you sure you want to delete Instaplay?'
                        break
                }
                this.alertDialog.i = i
                this.alertDialog.id = this.sortedInstaplays(mode)[i].InstaplayId
                this.alertDialog.action = action
                if (!alert) {
                    this.alertDialogAction()
                } else {
                    this.alertDialog.dialog = true
                }
            },
            openWSDialog(mode, i) {
                this.WSDialog.instaplay = this.sortedInstaplays(mode)[i]
                this.$refs.declareWinner.setStep(1)
                this.$refs.declareWinner.open()
            },
            showWinner(mode, i) {
                this.WSDialog.instaplay = this.sortedInstaplays(mode)[i]
                this.$refs.declareWinner.setStep(2)
                this.$refs.declareWinner.open()
            },
            removeInstaplay(mode, id) {
                this.status.delete = 'loading'
                this.deleteInstaplay({id, mode})
                    .then(() => {
                        if (this.isSuccess('edit')) {
                            this.status.delete = ''
                            this.alertDialog.dialog = false
                        }
                    })
            },
            openEditDialog(mode, i) {
                if (this.$refs.instaplayForm)
                    this.$refs.instaplayForm.reset()
                this.editDialog.instaplay = Object.assign({}, this.sortedInstaplays(mode)[i])
                this.$store.dispatch('instaplayForm/setForm', this.editDialog.instaplay)
                    .then(() => {
                        this.editDialog.dialog = true
                    })
            },
            closeEditDialog() {
                this.editDialog.dialog = false
                if (this.$refs.instaplayForm)
                    this.$refs.instaplayForm.reset()
            },
            editInstaplay() {
                this.closeEditDialog()
            }
        },
        mounted() {
            this.fetchIds()
        },
    }
</script>

<style scoped>

</style>
